import React from 'react';
import "./Experience.css";
import { FaAward, FaUsers, FaBuilding, FaChartLine } from 'react-icons/fa';

const Experience = () => {
  const stats = [
    { icon: <FaAward size={50} className="text-brown" />, value: "5+", label: "Años de Experiencia" },
    { icon: <FaUsers size={50} className="text-brown" />, value: "150+", label: "Propietarios Satisfechos" },
    { icon: <FaBuilding size={50} className="text-brown" />, value: "200+", label: "Propiedades Gestionadas" },
    { icon: <FaChartLine size={50} className="text-brown" />, value: "95%", label: "Tasa de Ocupación" }
  ];

  return (
    <div className='experience section-p' id="experience">
        <div className='container'>
            <div className='experience-content'>
                <div className='section-title'>
                    <h3 className='text-brown'>Nuestra <span className='text-dark'>Experiencia</span></h3>
                    <p className='text'>Somos un equipo de profesionales con años de experiencia en el sector inmobiliario, especializados en la optimización de activos y la gestión integral de propiedades.</p>
                </div>
                <div className='experience-stats grid'>
                    {stats.map((stat, index) => (
                        <div className='stat-item text-center' key={index}>
                            <div className='stat-icon'>{stat.icon}</div>
                            <h2 className='stat-value'>{stat.value}</h2>
                            <p className='stat-label'>{stat.label}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
  )
}

export default Experience